import swal from 'sweetalert2';

export default {
    methods: {
        capitalize: function (value) {
            return value[0].toUpperCase() + value.slice(1);
        },

        currency: function (value) {
            var parseValue = (value + '').replace(/[^0-9+\-Ee.]/g, '');
            return '$' + Number(parseValue).toLocaleString("en-US", {style: "currency", currency: "USD"}).substring(1);
        },

        notifyRollbar(message, error) {
            if (window.Rollbar) {
                window.Rollbar.debug(message, error);
            }
        },

        manageErrors: function(data) {
            $.loading.hide();
            var self = this;

            if (typeof data.status !== 'undefined' && (data.status === 422 || data.status === 417)) {
                var errors = data.body.errors;

                var htmlErrors = '';

                if (typeof errors === 'object') {
                    $.each(errors, function (index, value) {
                        htmlErrors += "\n" + value;
                    });
                } else {
                    htmlErrors += "\n" + errors;
                }

                swal.fire({
                    title: '',
                    text: htmlErrors,
                    type: "error"
                });
            } else if (data.body !== 'undefined' && typeof data.body.message !== 'undefined') {
                self.showErrorMessage(data.body.message);
            } else if (typeof data.responseJSON !== 'undefined') {
                self.showErrorMessage(data.responseJSON.message);
            } else if (typeof data.message !== 'undefined') {
                self.showErrorMessage(data.message);
            } else if (typeof data === 'string') {
                self.showErrorMessage(data);
            } else {
                self.showErrorMessage();
            }
        },

        showErrorMessage: function(text, callback) {
            var args = {
                title: '',
                html: typeof text != 'undefined' ? text : 'Looks like something went wrong. Please try again.',
                type: 'error'
            };
            if (typeof callback != 'undefined') {
                args.willClose = callback;
            }
            swal.fire(args);
        },

        showSuccessMessage: function(text, callback) {
            var args = {
                title: 'Success',
                html: text,
                type: 'success'
            };
            if (typeof callback != 'undefined') {
                args.willClose = callback;
            }
            swal.fire(args);
        },

        showConfirmMessage: function(text, callback) {
            var args = {
                title: 'Are you sure?',
                html: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            };

            swal.fire(args).then(() => {
                if (typeof callback != 'undefined') {
                    callback();
                }
            }).catch(swal.noop);
        },

        redirect: function (url) {
            window.location = url;
        },

        showLoading: function() {
            $('.loading').show();
        },

        hideLoading: function() {
            $('.loading').hide();
        }
    },

    filters: {
        capitalize: function (value) {
            return _.capitalize(value);
        },

        currency: function (value) {
            var parseValue = (value + '').replace(/[^0-9+\-Ee.]/g, '');
            return Number(parseValue).toLocaleString("en-US", {style: "currency", currency: "USD"});
        },

        formatDate: function (date) {
            return date ? moment(date).format('MM/DD/YYYY') : '';
        }
    }
};
